import dayjs, { Dayjs } from 'dayjs'
import { StateCreator } from 'zustand'
import { SharedSlice } from 'src/components/slice'
import { InvoicesSlice } from '../slice'
import { InvoiceStatusFilter } from '$constants'
import { parseSortModelToParamString } from 'src/components/common/helpers'

interface InvoiceHistoryState {
  invoiceHistoryFilters: {
    from: Dayjs
    to: Dayjs
    invoiceNumber: string
    supplierId: string
    status: InvoiceStatusFilter
  }
}

export interface InvoiceHistorySlice extends InvoiceHistoryState {
  resetInvoiceHistorySlice: () => void

  /**
   * Set Invoice History Filters
   * @param filters the filters to set
   */
  setInvoiceHistoryFilters: (
    filters: InvoiceHistoryState['invoiceHistoryFilters']
  ) => void
}

export const initialState: InvoiceHistoryState = {
  invoiceHistoryFilters: {
    from: dayjs().subtract(1, 'month').startOf('day'),
    to: dayjs(),
    invoiceNumber: '',
    supplierId: '',
    status: InvoiceStatusFilter.Received,
  },
}

const createInvoiceSlice: StateCreator<
  InvoiceHistorySlice & InvoicesSlice & SharedSlice,
  [],
  [],
  InvoiceHistorySlice
> = (set, get) => ({
  ...initialState,
  resetInvoiceHistorySlice: () => set(initialState),

  setInvoiceHistoryFilters: async (
    filters: InvoiceHistoryState['invoiceHistoryFilters']
  ): Promise<void> => {
    set(() => ({
      invoiceHistoryFilters: filters,
    }))

    await get().getInvoices({
      start: filters.from,
      end: filters.to,
      invoiceNumber: filters.invoiceNumber,
      supplierName: filters.supplierId,
      status: filters.status,
      page: get().paginationModel.page,
      pageSize: get().paginationModel.pageSize,
      sort: parseSortModelToParamString(get().sortModel),
    })
  },
})

export default createInvoiceSlice
